export const gas = {
  title: 'Natural Gas Module',
  subtitle: 'PODs, contracts, capacity booking, invoicing and reports.',
  nav: {
    group: 'Natural Gas',
    dashboard: 'Dashboard',
    pods: 'PODs',
    contracts: 'Contracts',
    readings: 'Meter Readings',
    invoices: 'Invoices',
    nominations: 'Nominations',
    customers: 'Gas Customers'
  },
  sections: {
    pods: 'Natural Gas PODs',
    contracts: 'Natural Gas Contracts',
    readings: 'Gas Meter Readings',
    invoices: 'Gas Invoices',
    nominations: 'Gas Nominations'
  },
  customer: {
    isGasCustomer: 'Gas Customer',
    badge: 'Gas',
    gasCustomersFilter: 'Gas Customers'
  },
  common: {
    new: 'New',
    add: 'Add',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    refresh: 'Refresh',
    search: 'Search',
    select: 'Select',
    upload: 'Upload',
    import: 'Import',
    export: 'Export',
    downloadExample: 'Download example',
    processing: 'Process',
    uploading: 'Uploading...',
    loading: 'Loading...',
    noData: 'No data available.',
    selectAll: 'Select all',
    selectedCount: 'selected'
  },
  pod: {
    id: 'POD ID',
    name: 'Name',
    address: 'Address',
    city: 'City',
    street: 'Street',
    postalCode: 'Postal Code',
    country: 'Country',
    meterSerialNumber: 'Meter Serial',
    meterType: 'Meter Type',
    gasQuality: 'Gas Quality',
    measurementType: 'Measurement Type',
    capacityKw: 'Capacity (kW)',
    maxHourlyCapacityM3: 'Max. Hourly Capacity (m³/h)',
    status: 'Status',
    statuses: {
      active: 'Active',
      inactive: 'Inactive',
      terminated: 'Terminated'
    },
    noPodAvailable: 'No gas POD available. Please add PODs first.',
    errors: {
      podIdRequired: 'POD ID is required',
      addressRequired: 'Address is required'
    },
    fields: {
      postalCode: 'Postal Code',
      city: 'City',
      street: 'Street',
      houseNumber: 'House Number',
      plotNumber: 'Plot Number',
      measurementType: 'Measurement Type',
      gasQuality: 'Gas Quality',
      meterSerialNumber: 'Meter Serial Number',
      meterType: 'Meter Type',
      placeholder: {
        podId: 'Metering point code',
        name: 'Optional'
      }
    }
  },
  contract: {
    number: 'Contract Number',
    type: 'Contract Type',
    types: {
      energy: 'Energy (molecule)',
      rhd_variable: 'RHD variable',
      rhd_fixed: 'RHD fixed / capacity'
    },
    startDate: 'Start Date',
    endDate: 'End Date',
    capacityKwh: 'Capacity (kWh)',
    capacityM3: 'Capacity (m³)',
    maxHourlyCapacityM3: 'Max. Hourly Capacity (m³/h)',
    price: 'Price',
    priceUnit: 'Unit',
    currency: 'Currency',
    spread: 'Spread',
    vatRate: 'VAT %',
    isFixedPrice: 'Fixed Price',
    linkedPods: 'Linked PODs',
    linkedPodsCount: 'linked PODs',
    status: 'Status',
    statuses: {
      draft: 'Draft',
      active: 'Active',
      expired: 'Expired',
      terminated: 'Terminated'
    },
    unnamed: 'Unnamed contract',
    fields: {
      contractNumber: 'Contract Number',
      contractType: 'Contract Type',
      startDate: 'Start Date',
      endDate: 'End Date',
      capacityKwh: 'Capacity (kWh)',
      capacityM3: 'Capacity (m³)',
      maxHourlyCapacityM3: 'Max. Hourly Capacity (m³/h)',
      price: 'Price',
      priceUnit: 'Unit',
      currency: 'Currency',
      spread: 'Spread',
      vatRate: 'VAT %',
      isFixedPrice: 'Fixed Price',
      linkedPods: 'Linked PODs',
      notes: 'Notes',
      placeholder: {
        contractNumber: 'e.g. GAS-2026-001',
        price: '0.00',
        priceUnit: 'HUF/kWh or HUF/m³'
      }
    },
    errors: {
      contractTypeRequired: 'Contract type is required',
      startDateRequired: 'Start date is required'
    }
  },
  reading: {
    gasDay: 'Gas Day',
    readingDate: 'Reading Date',
    meterStatus: 'Meter Status (m³)',
    consumptionM3: 'Consumption (m³)',
    energyKwh: 'Energy (kWh)',
    calorificValue: 'Calorific Value (MJ/m³)',
    correctionFactor: 'Correction Factor',
    status: 'Status',
    statuses: {
      estimated: 'Estimated',
      read: 'Read',
      corrected: 'Corrected'
    },
    source: 'Source',
    sources: {
      manual: 'Manual',
      mscsons: 'MSCONS',
      invoice: 'Invoice',
      import: 'Import'
    },
    bulkUpload: 'Bulk Meter Reading Upload',
    bulkFormat: 'Format: POD_ID;GAS_DAY;METER_STATUS;CONSUMPTION_M3;ENERGY_KWH',
    bulkExample: 'gas_meter_reading_example.csv',
    bulkMessages: {
      noInput: 'Please enter at least one reading',
      invalidRows: '{{count}} invalid rows found',
      parsedRows: '{{count}} readings processed',
      noSelectedRows: 'No valid selected readings',
      uploadedRows: '{{count}} readings uploaded',
      uploadError: 'Error uploading readings',
      errors: {
        podIdAndGasDayRequired: 'POD ID and gas day are required',
        unknownPodId: 'Unknown POD ID',
        invalidGasDayFormat: 'Invalid gas day format (YYYY-MM-DD)',
        invalidMeterStatus: 'Invalid meter status',
        invalidConsumption: 'Invalid consumption (m³)',
        invalidEnergy: 'Invalid energy (kWh)'
      }
    },
    fields: {
      gasPod: 'Gas POD',
      gasDay: 'Gas Day',
      readingDate: 'Reading Date',
      meterStatus: 'Meter Status (m³)',
      consumptionM3: 'Consumption (m³)',
      energyKwh: 'Energy (kWh)',
      calorificValue: 'Calorific Value (MJ/m³)',
      correctionFactor: 'Correction Factor',
      status: 'Status',
      source: 'Source',
      note: 'Note'
    },
    errors: {
      podRequired: 'Please select a gas POD',
      gasDayRequired: 'Gas day is required'
    }
  },
  invoice: {
    period: 'Period',
    periodStart: 'Period Start',
    periodEnd: 'Period End',
    gasDays: 'Gas Days',
    invoiceNumber: 'Invoice Number',
    status: 'Status',
    statuses: {
      draft: 'Draft',
      issued: 'Issued',
      paid: 'Paid',
      cancelled: 'Cancelled'
    },
    lines: 'Invoice Lines',
    lineType: 'Type',
    lineTypes: {
      energy: 'Energy',
      rhd: 'RHD',
      capacity: 'Capacity',
      penalty: 'Penalty',
      fee: 'Fee',
      other: 'Other'
    },
    autoFill: 'Auto-fill',
    autoFillSuccess: 'invoice lines generated',
    autoFillError: 'No reading or price available for auto-fill',
    noLines: 'No invoice lines yet. Add at least one.',
    totalNet: 'Net',
    totalVat: 'VAT',
    totalGross: 'Gross',
    errors: {
      contractRequired: 'Please select a valid contract',
      periodRequired: 'Please specify the period',
      noLines: 'At least one invoice line is required'
    },
    fields: {
      contract: 'Contract (for auto-fill)',
      billingPeriodStart: 'Period Start',
      billingPeriodEnd: 'Period End',
      gasDays: 'Gas Days',
      invoiceNumber: 'Invoice Number',
      currency: 'Currency',
      status: 'Status',
      notes: 'Notes',
      lines: 'Invoice Lines',
      lineDescription: 'Description',
      lineType: 'Type',
      lineQuantity: 'Quantity',
      lineUnit: 'Unit',
      lineUnitPrice: 'Unit Price',
      lineVatRate: 'VAT %',
      addLine: 'Add Line',
      autoFill: 'Auto-fill',
      placeholder: {
        selectContract: 'Select contract',
        invoiceNumber: 'e.g. INV-2026-001'
      }
    }
  },
  nomination: {
    type: 'Nomination Type',
    types: {
      day_ahead: 'Day-ahead',
      within_day: 'Within-day',
      long_term: 'Long-term'
    },
    status: 'Status',
    statuses: {
      draft: 'Draft',
      submitted: 'Submitted',
      confirmed: 'Confirmed',
      rejected: 'Rejected'
    },
    gasDay: 'Gas Day',
    quantityM3: 'Quantity (m³)',
    quantityKwh: 'Quantity (kWh)',
    submit: 'Submit',
    confirm: 'Confirm',
    noQuantity: 'No quantity',
    fields: {
      contract: 'Contract (optional)',
      pod: 'POD (optional)',
      selectContract: 'No contract selected',
      selectPod: 'No POD selected',
      gasDay: 'Gas Day',
      type: 'Nomination Type',
      quantityM3: 'Quantity (m³)',
      quantityKwh: 'Quantity (kWh)',
      status: 'Status',
      notes: 'Notes'
    },
    errors: {
      gasDayRequired: 'Gas day is required',
      typeRequired: 'Nomination type is required'
    }
  },
  messages: {
    loadError: 'Error loading {{name}}',
    saveSuccess: '{{name}} saved successfully',
    saveError: 'Error saving {{name}}',
    deleteSuccess: '{{name}} deleted successfully',
    deleteError: 'Error deleting {{name}}',
    addSuccess: '{{name}} added successfully',
    addError: 'Error adding {{name}}',
    autoFillSuccess: 'Invoice lines auto-filled successfully',
    autoFillError: 'Error during auto-fill',
    confirmDelete: 'Are you sure you want to delete this item?',
    confirmSubmit: 'Are you sure you want to submit this nomination?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    ok: 'OK'
  },
  list: {
    title: '{{name}} list',
    subtitle: '{{count}} items',
    refresh: 'Refresh',
    noResults: 'No items to display.',
    search: {
      pods: 'Search by POD ID, address or customer...',
      contracts: 'Search by contract number, type or status...',
      readings: 'Search by gas day, POD ID or customer...',
      invoices: 'Search by invoice number, period or contract...',
      nominations: 'Search by gas day, contract or status...'
    }
  },
  dashboard: {
    gasCustomerSubtitle: 'At least one gas POD or contract',
    podsSubtitle: 'Natural gas POD master data and metering points',
    readingsSubtitle: 'Recorded gas meter readings',
    nominationsSubtitle: 'Submitted and confirmed nominations',
    activeTitle: 'Gas module active',
    activeDescription: 'The natural gas module core features are ready: POD management, contracts, meter readings, invoicing and nominations.'
  },
  calendar: {
    title: 'Calendar',
    currentGasDay: 'Current Gas Day',
    currentGasYear: 'Current Gas Year'
  },
  alerts: {
    expiringContracts: 'Gas contracts expiring soon',
    expiresToday: 'Expires today',
    daysRemaining: 'days remaining',
    moreContracts: 'more contracts'
  }
};
